import styles from './Footer.module.css';

export default function Footer({ attribution, details }) {
  return (
    <footer className={styles.siteFooter}>
      <div className={styles.footerMeta}>
        {details.slice(0, 2).map((detail) => <span key={detail}>{detail}</span>)}
      </div>
      <div className={styles.footerBrandWrap}><img src="/verticallogo.png" alt="M80" className={styles.footerLogo} /></div>
      <div className={`${styles.footerMeta} ${styles.footerMetaRight}`}>
        {details.slice(2).map((detail) => <span key={detail}>{detail}</span>)}
      </div>
      <p className={styles.footerPowered}>Website powered by <a href={attribution.href} target="_blank" rel="noopener noreferrer">{attribution.label}</a></p>
    </footer>
  );
}